import { PageHeader, BreadcrumbItem } from "@/components/feature/PageHeader";
import { CreateGroupWizard } from "../components/CreateGroupWizard";

export default function CreateGroupPage() {
  return (
    <div>
      <PageHeader
        breadcrumb={
          <>
            <BreadcrumbItem label="Home" to="/" />
            <BreadcrumbItem label="Groups" to="/groups" />
            <BreadcrumbItem label="Create group" isLast />
          </>
        }
        title="Create a group"
        subtitle="Set up a new kameti, then enrol members into numbered tickets before activating."
      />
      <CreateGroupWizard />
    </div>
  );
}